module.exports = __webpack_public_path__ + "img/7.3c39c460.jpg";